import { Sidebar } from '../components/Sidebar';
import BitcoinNews from '../components/BitcoinNews';
import { Newspaper } from 'lucide-react';

const News = () => {
  return (
    <div className="min-h-screen py-12 md:py-16" data-testid="news-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex items-start gap-4 mb-10 md:mb-12">
          <div className="hidden sm:flex w-14 h-14 rounded-2xl bg-primary/10 items-center justify-center shrink-0">
            <Newspaper className="text-primary" size={28} />
          </div>
          <div>
            <h1 className="text-3xl md:text-5xl font-bold tracking-tight">Notícias do Bitcoin</h1>
            <p className="text-muted-foreground mt-2 text-base md:text-lg max-w-2xl">
              As últimas notícias do universo Bitcoin, traduzidas, contextualizadas e explicadas em português brasileiro.
              Curadoria automática feita por IA, com revisão diária.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <BitcoinNews />
          </div>

          <div className="lg:sticky lg:top-24 h-fit">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
